import FarmerInviteStatusButton from "../components/microComponents/FarmerInviteStatusButton";
import SurveyProgressBar from "../components/microComponents/SurveyProgressBar";
import { chartTypes, farmerInviteStatus, questionTypes } from "./constants";

export const msqQuestions = [
  {
    text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet in omnis maiores magnam? Perferendis natus nihil quibusdam. Accusantium ipsa tempora at deleniti provident! Quod vel ullam fugiat minus vitae atque autem.",
    type: questionTypes["mcq"],
    options: ["Paris", "London", "Berlin", "Madrid"],
  },
  {
    text: "What is the capital of Germany?",
    type: questionTypes["mcq"],
    options: ["Paris", "London", "Berlin", "Madrid"],
  },
  {
    text: "What is the capital of Spain?",
    type: questionTypes["mcq"],
    options: ["Paris", "London", "Berlin", "Madrid"],
  },
  {
    text: "What is the capital of Italy?",
    type: questionTypes["mcq"],
    options: ["Paris", "London", "Berlin", "Madrid"],
  },
  {
    text: "What is the capital of Portugal?",
    type: questionTypes["mcq"],
    options: ["Paris", "London", "Berlin", "Madrid"],
  },
  {
    text: "What is the capital of Poland?",
    type: questionTypes["mcq"],
    options: ["Paris", "London", "Berlin", "Madrid"],
  },
  {
    text: "What is the capital of Sweden?",
    type: questionTypes["mcq"],
    options: ["Paris", "London", "Berlin", "Madrid"],
  },
  {
    text: "What is the capital of Norway?",
    type: questionTypes["mcq"],
    options: ["Paris", "London", "Berlin", "Madrid"],
  },
  {
    text: "What is the capital of Finland?",
    type: questionTypes["mcq"],
    options: ["Paris", "London", "Berlin", "Madrid"],
  },
];

export const rangeQuestions = [
  {
    text: "What is your age?",
    type: questionTypes["range"],
    min: 18,
    max: 100,
  },
  {
    text: "How many years of experience do you have?",
    type: questionTypes["range"],
    min: 0,
    max: 50,
  },
  {
    text: "How many hours do you work in a week?",
    type: questionTypes["range"],
    min: 0,
    max: 168,
  },
  {
    text: "How many hours do you sleep in a day?",
    type: questionTypes["range"],
    min: 0,
    max: 24,
  },
];

export const textQuestions = [
  {
    text: "What is your name?",
    type: questionTypes["text"],
  },
  {
    text: "What is your email?",
    type: questionTypes["text"],
  },
  {
    text: "What is your phone number?",
    type: questionTypes["text"],
  },
  {
    text: "What is your address?",
    type: questionTypes["text"],
  },
];

export const numberQuestions = [
  {
    text: "What is your age?",
    type: questionTypes["number"],
  },
  {
    text: "What is your weight?",
    type: questionTypes["number"],
  },
  {
    text: "What is your height?",
    type: questionTypes["number"],
  },
  {
    text: "What is your phone number?",
    type: questionTypes["number"],
  },
];

export const checkboxQuestions = [
  {
    text: "What is your favourite color?",
    type: questionTypes["checkbox"],
    options: ["Red", "Blue", "Green", "Yellow"],
  },
  {
    text: "What is your favourite animal?",
    type: questionTypes["checkbox"],
    options: ["Dog", "Cat", "Elephant", "Lion"],
  },
  {
    text: "What is your favourite food?",
    type: questionTypes["checkbox"],
    options: ["Pizza", "Burger", "Pasta", "Noodles"],
  },
  {
    text: "What is your favourite movie?",
    type: questionTypes["checkbox"],
    options: ["Inception", "Interstellar", "The Dark Knight", "Tenet"],
  },
];

export const mockFarmerDetails = () => {
  const barHeight = "h-6";

  return (
    <>
      <tr>
        <td className="border px-4 py-2 text-center font-normal text-md">
          John Doe
        </td>
        <td className="border px-4 py-2 text-center font-normal text-md">
          csdv@sdkfjn.cpom
        </td>
        <td className="border px-4 py-2 text-center font-normal text-md">
          +234567890
        </td>
        <td className="border px-4 py-2 flex justify-center">
          <FarmerInviteStatusButton
            status={farmerInviteStatus["pending"]}
            barHeight={barHeight}
          />
        </td>
        <td className="border px-4 py-2 text-center font-normal text-md">-</td>
      </tr>
      <tr>
        <td className="border px-4 py-2 text-center">Jane Doe</td>
        <td className="border px-4 py-2 text-center">csdv@sdkfjn.cpom</td>
        <td className="border px-4 py-2 text-center">+234567890</td>
        <td className="border px-4 py-2 flex justify-center">
          <FarmerInviteStatusButton
            status={farmerInviteStatus["accepted"]}
            barHeight={barHeight}
          />
        </td>
        <td className="border px-4 py-2 ">
          {/* <div className="w-10 h-7 bg-slate-400"></div> */}
          {/* 100% */}
          <SurveyProgressBar barHeight={barHeight} percentage={100} />
        </td>
      </tr>
      <tr>
        <td className="border px-4 py-2 text-center">Jane Doe</td>
        <td className="border px-4 py-2 text-center">csdv@sdkfjn.cpom</td>
        <td className="border px-4 py-2 text-center">+234567890</td>
        <td className="border px-4 py-2 flex justify-center">
          <FarmerInviteStatusButton status={farmerInviteStatus["accepted"]} />
        </td>
        <td className="border px-4 py-2 text-center font-normal text-md">
          <SurveyProgressBar barHeight={barHeight} percentage={90} />
        </td>
      </tr>
      <tr>
        <td className="border px-4 py-2 text-center">Jane Doe</td>
        <td className="border px-4 py-2 text-center">csdv@sdkfjn.cpom</td>
        <td className="border px-4 py-2 text-center">+234567890</td>
        <td className="border px-4 py-2 flex justify-center">
          <FarmerInviteStatusButton status={farmerInviteStatus["accepted"]} />
        </td>
        <td className="border px-4 py-2 text-center font-normal text-md">
          <SurveyProgressBar barHeight={barHeight} percentage={50} />
        </td>
      </tr>
      <tr>
        <td className="border px-4 py-2 text-center">Jane Doe</td>
        <td className="border px-4 py-2 text-center">csdv@sdkfjn.cpom</td>
        <td className="border px-4 py-2 text-center">+234567890</td>
        <td className="border px-4 py-2 flex justify-center">
          <FarmerInviteStatusButton status={farmerInviteStatus["accepted"]} />
        </td>
        <td className="border px-4 py-2 text-center font-normal text-md">
          <SurveyProgressBar barHeight={barHeight} percentage={75} />
        </td>
      </tr>
      <tr>
        <td className="border px-4 py-2 text-center">Jane Doe</td>
        <td className="border px-4 py-2 text-center">csdv@sdkfjn.cpom</td>
        <td className="border px-4 py-2 text-center">+234567890</td>
        <td className="border px-4 py-2 flex justify-center">
          <FarmerInviteStatusButton status={farmerInviteStatus["accepted"]} />
        </td>
        <td className="border px-4 py-2 text-center font-normal text-md">
          <SurveyProgressBar barHeight={barHeight} percentage={25} />
        </td>
      </tr>
      <tr>
        <td className="border px-4 py-2 text-center">Jane Doe</td>
        <td className="border px-4 py-2 text-center">csdv@sdkfjn.cpom</td>
        <td className="border px-4 py-2 text-center">+234567890</td>
        <td className="border px-4 py-2 flex justify-center">
          <FarmerInviteStatusButton status={farmerInviteStatus["accepted"]} />
        </td>
        <td className="border px-4 py-2 text-center font-normal text-md">
          <SurveyProgressBar barHeight={barHeight} percentage={0} />
        </td>
      </tr>
      <tr>
        <td className="border px-4 py-2 text-center">Jane Doe</td>
        <td className="border px-4 py-2 text-center">csdv@sdkfjn.cpom</td>
        <td className="border px-4 py-2 text-center">+234567890</td>
        <td className="border px-4 py-2 flex justify-center">
          <FarmerInviteStatusButton status={farmerInviteStatus["rejected"]} />
        </td>
        <td className="border px-4 py-2 text-center font-normal text-md">-</td>
      </tr>
    </>
  );
};

// mock data custom line graph
export const mockCustomLineGraphData = {
  question_text: 'Reduction in GHG Emissions Across Farms (AVG.) (%)',
  graph_type: chartTypes["line"],
  order: 3,
  answer: [
    {
      year: 2024,
      value: 100,
    },
  ],
  this_year: [
    {
      year: 2024,
      value: 100,
    },
  ],
}


export const esgMetrics = [
  {
    value: '10%',
    description: 'Reduction in GHG Emissions from Operations',
    backgroundColor: 'bg-emerald-400'
  },
  {
    title: 'Scope 2 - Renewable Energy',
    value: '52%',
    description: 'Energy Across our Farms Comes From Renewable Sources',
    backgroundColor: 'bg-emerald-400'
  },
  {
    title: 'Scope 3',
    value: '30%',
    description: 'GHG Emissions Reduced from our Supply Chain',
    backgroundColor: 'bg-emerald-400'
  },
  {
    title: 'Water Restoration',
    value: '1 billion',
    description: 'Liters of Water Restored',
    backgroundColor: 'bg-amber-400'
  }
];


// Mock data for the map of all states of the US with percentage between 0 and 100
export const mapMockData = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  // "Montana",
  // "Nebraska",
  // "Nevada",
  // "New Hampshire",
  // "New Jersey",
  // "New Mexico",
  // "New York",
  // "North Carolina",
  // "North Dakota",
  // "Ohio",
  // "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  // "Virginia",
  // "Washington",
  // "West Virginia",
  // "Wisconsin",
  // "Wyoming", 'Georgia'
];

export const newDataForBarChart = {
  "Fruits": {
    "African Americans": 20,
    "White Americans": 20,
    "Asian Americans": 20,
    "American Indian": 20,
    "Hispanic": 20
  },
  "Grains": {
    "African Americans": 20,
    "White Americans": 20,
    "Asian Americans": 20,
    "American Indian": 43,
    "Hispanic": 20
  },
  "Meat": {
    "African Americans": 20,
    "White Americans": 13,
    "Asian Americans": 20,
    "American Indian": 20,
    "Hispanic": 20
  },
  "Poultry & Eggs": {
    "African Americans": 20,
    "White Americans": 20,
    "Asian Americans": 30,
    "American Indian": 20,
    "Hispanic": 20
  },
  "Specialty & Crops": {
    "African Americans": 30,
    "White Americans": 20,
    "Asian Americans": 30,
    "American Indian": 20,
    "Hispanic": 20
  },
  "Vegetables": {
    "African Americans": 20,
    "White Americans": 20,
    "Asian Americans": 20,
    "American Indian": 50,
    "Hispanic": 20
  }
};

// Transform the newData into the format required by BarChart
export const transformedEthnicityData = Object.keys(newDataForBarChart).map(category => ({
  category,
  "African Americans": newDataForBarChart[category]["African Americans"],
  "White Americans": newDataForBarChart[category]["White Americans"],
  'Asian Americans': newDataForBarChart[category]["Asian Americans"],
  'American Indian': newDataForBarChart[category]["American Indian"],
  Hispanic: newDataForBarChart[category]["Hispanic"],
}));

// Transform answer data into the required format
export const mockAnswerLineGraph = {
  "January": 0,
  "February": 0,
  "March": 0,
  "April": 0,
  "May": 0,
  "June": 0,
  "July": 0,
  "August": 0,
  "September": 0,
  "October": 0,
  "November": 0,
  "December": 0
};

export const mockDashboardData = {
  status: 200,
  result: {
    response: [
      {
        order: "10",
        answer: 1000,  // Total acreage
        average: 75
      },
      {
        order: "17",
        answer: 30,    // Percentage for converted land calculation
        average: 30
      },
      {
        order: "3",
        answer: 45,
        average: 45    // Reduction in Fertilizer & Pesticide Use
      },
      {
        order: "4",
        answer: 50000, // Gallons of Water Restored
        average: 50
      },
      {
        order: "5",
        answer: 65,    // Renewable Energy percentage
        average: 65
      },
      {
        order: "6",
        answer: 85,    // Animal Welfare percentage
        average: 85
      },
      {
        order: "7",
        answer: 40,    // Socio-Economic Diversity percentage
        average: 40
      },
      {
        order: "9",
        answer: 250,   // Number of Farmer Trainings
        average: 250
      }
    ]
  }
};

// This will be the transformed data after processing
export const mockProcessedDashboardData = [{
  title: 'WELLBEING',
  value: '0%',
  description: 'Reduction in Fertilizer & Pesticide Use',
  backgroundColor: '#39bf90'
},
{
  title: 'REGENRATIVE AGRICULTURE',
  value: '0 acres',
  description: 'of Land Converted to Regenerative Agricultural Practice',
  backgroundColor: '#e9bd52'
},
{
  title: 'WATER RESTORATION',
  value: '0 gallons',
  description: 'Gallons of Water Restored',
  backgroundColor: '#9968ea'
},
{
  title: 'RENEWABLE ENERGY',
  value: '0%',
  description: 'Energy Across our Farms Comes From Renewable Sources',
  backgroundColor: '#ef638a'
},
{
  title: 'ANIMAL WELFARE',
  value: '0%',
  description: 'Procurment from farms that Follow Animal Welfare Standards',
  backgroundColor: '#e9bd52'
},
{
  title: 'SOCIO-ECONOMIC DIVERSITY',
  value: '0%',
  description: 'Procurment form Different Ethinic and Socio Economic Groups',
  backgroundColor: '#39bf90'
},
{
  title: 'TRAININGS',
  value: '0',
  description: 'Farmer Trainings Delivered',
  backgroundColor: '#9968ea'
}
];